import { useEffect, useState } from 'react';
import { RecordContextProvider, ReferenceField, TextField, useDataProvider, useNotify, usePermissions } from 'react-admin';
import { DashboardWrapper } from '../../components';
import { PERMISSIONS } from '../../constants';
import useDashboardContext from '../../hooks/useDashboardContext';
import { getChainId } from '../../lib';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { TableHead } from '@mui/material';

const RANK_ATTENDANT_LIMIT = 10;

const tableSx = {
  minWidth: 280,
  border: '1px solid #DFE2E6',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
};

const tableRowSx = {
  textDecoration: 'none',
  '&:hover': {
    backgroundColor: 'action.hover',
    cursor: 'pointer',
  },
};

const headerCellSx = {
  backgroundColor: '#f5f5f5',
  fontWeight: 'bold',
  color: '#333',
};

const rankCellSx = {
  fontWeight: 'bold',
  color: '#4CAF50',
};

const nameCellSx = {
  fontSize: '14px',
  fontWeight: 'normal',
};

const totalCellSx = {
  color: '#888',
  fontWeight: 'bold',
};

// Unused styles kept as comments for reference
// const topAttendantSx = {
//   backgroundColor: '#ffeb3b', // Yellow for the top 1
// };
// const secondAttendantSx = {
//   backgroundColor: '#8bc34a', // Green for second place
// };
// const thirdAttendantSx = {
//   backgroundColor: '#03a9f4', // Blue for third place
// };

export const RankAttendants = () => {
  const [attendantsData, setAttendantsData] = useState(null);
  const { permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const { chain, from, to, origin, stationIds } = useDashboardContext();

  const chainId = permissions && permissions.includes(PERMISSIONS.ADMIN) ? chain : getChainId();

  useEffect(() => {
    const filter = {
      limit: RANK_ATTENDANT_LIMIT,
      from,
      to,
    };

    if (stationIds && stationIds.length > 0) { filter.placeIds = stationIds; }
    if (origin) { filter.origin = origin; }

    if (permissions && permissions.includes(PERMISSIONS.RANK_ATTENDANTS)) {
      dataProvider.getList('dashboard/rank-attendants', { filter, chainId })
        .then(response => {
          const attendants = response.data;
          attendants.forEach((attendant, index) => {
            attendant.rank = index + 1;
          });
          setAttendantsData(attendants);
        })
        .catch((e) => { notify('Erro ao carregar o ranking de frentistas', { type: 'warning' }); });
    }
  }, [permissions, from, to, chain, stationIds, origin]);

  return (
    <DashboardWrapper
      permission={PERMISSIONS.RANK_ATTENDANTS}
      title="Top Frentistas"
      width="50%"
      loading={attendantsData === null}
      content={
        <TableContainer>
          {attendantsData && attendantsData.length > 0 ?
            <Table sx={tableSx} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ ...headerCellSx, minWidth: 20 }}>#</TableCell>
                  <TableCell sx={headerCellSx}>Frentista</TableCell>
                  <TableCell sx={headerCellSx} align="right">Abastecimentos</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {attendantsData.map((item, index) => {
                  // let rankSx = {};
                  // if (index === 0) rankSx = topAttendantSx;
                  // else if (index === 1) rankSx = secondAttendantSx;
                  // else if (index === 2) rankSx = thirdAttendantSx;

                  return (
                    <RecordContextProvider key={item.id} value={item}>
                      <TableRow sx={tableRowSx} key={item.id}>
                        <TableCell sx={rankCellSx}>{item.rank}</TableCell>
                        <TableCell sx={nameCellSx}>
                          <ReferenceField
                            source="id"
                            reference="attendants"
                            record={item}
                            link="show"
                          >
                            <TextField source="name" />
                          </ReferenceField>
                        </TableCell>
                        <TableCell sx={totalCellSx} align="right">{item.total}</TableCell>
                      </TableRow>
                    </RecordContextProvider>
                  );
                })}
              </TableBody>
            </Table>
            : <p style={{ textAlign: 'center' }}>Sem dados para exibir</p>}
        </TableContainer>
      }
    />
  );
}
